<script setup>
const emit = defineEmits(['resolve'])

const confirm = () => emit('resolve', 'confirmed')
const close = () => emit('resolve', null)
</script>

<template>
  <ImoModal_ @close="close" size="sm" title="Aviso">
    <template #body>
      <div class="flex flex-col items-center justify-center px-6 py-6 text-center">
        <ImoIcon name="clock" :size="64" class="text-warning-60 mb-4" />
        <p class="text-neutral-80 text-sm">
          O relatório pode demorar a ficar pronto, enquanto isso você pode continuar usando o
          sistema normalmente. Não feche o sistema antes do download do arquivo.
        </p>
      </div>
    </template>
    <template #footer>
      <div class="flex w-full justify-end px-4 py-2">
        <ImoButton @click="confirm" text="Entendi" size="sm" variant="primary" />
      </div>
    </template>
  </ImoModal_>
</template>
